import styled from "@emotion/styled";
import { black, orange } from "@stepfinance/react";
import type { FC } from "react";

import { useLanguageContext } from "../../contexts/language/language";
import { useSolanaPerformance } from "../../hooks";

export const DegradedPerformanceBanner: FC = () => {
  const degradedPerformance = useSolanaPerformance();
  const {
    currentLanguageData: {
      pages: {
        allPages: { lowTPSWarning },
      },
    },
  } = useLanguageContext();

  return (
    <>
      {degradedPerformance && (
        <DegradedPerformanceBannerStyled>
          <span>{lowTPSWarning}</span>
        </DegradedPerformanceBannerStyled>
      )}
    </>
  );
};

const DegradedPerformanceBannerStyled = styled.div`
  width: 100%;
  height: min-content;
  padding: 10px 0;

  line-height: 16px;
  text-align: center;
  background: ${orange};
  color: ${black};
  font-weight: 500;
  z-index: 5;
`;
